import { nameRoutes } from "../../router/nameRoutes";

import { getVassoioItem, updatePortata } from "../../utils/richieste/api";
import { DESCRIZIONEALLERGENI } from "../../utils/richieste/data";

import { makeToast, TOAST_RESULT } from "../../Toast";
import N4M from "../../utils/commons";
import LABEL from "../../utils/label";

export const portataMixin = {
  data() {
    return {
      LABEL,
      nameRoutes,

      loader: {
        page: true,
        update: false,
      },

      portata: {
        piatti: [],
        piattiIniziali: [],
        idVassoio: null,
        nomePortata: "",
        nomePasto: "",
        dataRichiesta: "",
        massimoPiattiSelezionabili: 1,
      },

      lateralCard: {
        open: false,
        details: {},
      },

      checkbox: {
        selectedLabel: LABEL.PORTATA.SELECTED_CHECKBOX,
        selectedIcon: "check",
        notSelectedLabel: LABEL.PORTATA.NOT_SELECTED_CHECKBOX,
        notSelectedIcon: "hand-pointer",
        requiredLabel: LABEL.PORTATA.REQUIRED_CHECKBOX,
        requireIcon: "check",
        requiredHelp: "Non puoi deselezionare questo piatto",
      },

      errors: {
        alert: null,
        update: false,
        change: false,
      },
    };
  },

  methods: {
    setAll: async function () {
      const { idRichiesta, idVassoioItem, idPortata } = this.$route.params;

      const {
        result,
        data: vassoio,
        code,
      } = await getVassoioItem(idRichiesta, idVassoioItem, idPortata);

      if (result === "KO") {
        this.loader.page = false;
        this.errors.alert = code;
        return;
      }

      this.portata = {
        piatti: this.mapPortata(vassoio),

        idVassoio: vassoio.listaPiatti[0].idVassoio,

        nomePortata: N4M.CAPITALIZESTRING(vassoio.descrizionePortata),

        nomePasto: N4M.CAPITALIZESTRING(vassoio.descrizionePasto),

        dataRichiesta: vassoio.dataRichiesta,

        massimoPiattiSelezionabili: vassoio.massimoPiattiSelezionabili,
      };

      this.portata.piattiIniziali = N4M.COPYPOBJECTSARRAY(this.portata.piatti);

      this.loader.page = false;
    },

    mapPortata: function (vassoio) {
      return vassoio.listaPiatti.map((piatto) => {
        return {
          id: piatto.idPiatto,

          label: [
            {
              text: N4M.CAPITALIZESTRING(piatto.descrizione),
            },
          ],

          checkbox: true,

          // Mantengo tutti i dati backend
          ...N4M.REMOVEENTRIES({ ...piatto }, ["allergeni", "descrizione"]),

          ...this.mapAllergeni(piatto),
        };
      });
    },

    mapAllergeni: function ({ allergeni, descrizione }) {
      return Object.entries(allergeni) && !!Object.entries(allergeni).length
        ? {
            details: {
              buttonLabel: LABEL.PORTATA.ALLERGENS_LABEL,

              detailsList: Object.entries(allergeni).map((allergeniCode) =>
                N4M.CAPITALIZESTRING(DESCRIZIONEALLERGENI[allergeniCode[0]]),
              ),

              detailsListTitle: N4M.CAPITALIZESTRING(
                LABEL.PORTATA.ALLERGENS_TITLE(descrizione.toLowerCase()),
              ),
            },
          }
        : null;
    },

    checkboxChange: function (piattoToChange) {
      if (piattoToChange.obbligatorio && piattoToChange.selezionato) {
        return;
      }

      const numeroPiattiLiberiSelezionati = this.portata.piatti.filter(
        (piatto) => piatto.selezionato && !piatto.obbligatorio,
      ).length;

      if (!piattoToChange.selezionato) {
        if (
          numeroPiattiLiberiSelezionati >=
          this.portata.massimoPiattiSelezionabili
        ) {
          makeToast(TOAST_RESULT.KO, LABEL.TOAST.MAX_PLATE_ERROR);

          return;
        }
      }

      this.portata.piatti = this.portata.piatti.map((piatto) => {
        // Toggle del piatto cliccato
        if (piatto.id === piattoToChange.id) {
          return {
            ...piatto,
            selezionato: !piatto.selezionato,
          };
        }

        if (
          this.portata.massimoPiattiSelezionabili === 1 &&
          !piatto.obbligatorio
        ) {
          return {
            ...piatto,
            selezionato: false,
          };
        }

        return piatto;
      });
    },

    updatePortata: async function () {
      const piatti = this.mapPiattiToDto(this.portata.piatti);

      const piattiIniziali = this.mapPiattiToDto(this.portata.piattiIniziali);

      const piattiLiberiDaSalvare = piatti.filter(
        (piatto) => piatto.selezionato && !piatto.obbligatorio,
      ).length;

      // Verifica limite massimo
      if (piattiLiberiDaSalvare > this.portata.massimoPiattiSelezionabili) {
        makeToast(TOAST_RESULT.WARN, LABEL.TOAST.MAX_PLATE_SAVING_WARN);

        return;
      }

      let modificaEffettuata = !piatti.every(
        (piatto) =>
          piattiIniziali.filter(
            (piattoIniziale) => piattoIniziale.idPiatto === piatto.idPiatto,
          )[0].selezionato === piatto.selezionato,
      );

      if (!modificaEffettuata) {
        makeToast(TOAST_RESULT.WARN, LABEL.TOAST.NO_CHANGES_WARN);

        return;
      }

      this.loader.update = true;

      const { idRichiesta, idVassoioItem, idPortata } = this.$route.params;

      const { result } = await updatePortata(
        idRichiesta,
        idVassoioItem,
        idPortata,
        piatti,
      );

      if (result === "KO") {
        makeToast(TOAST_RESULT.KO, LABEL.TOAST.GENERIC_ERROR);

        this.errors.update = true;
      } else {
        makeToast(TOAST_RESULT.OK, LABEL.TOAST.SAVED);

        this.backToVassoio();
      }

      this.loader.update = false;
    },

    mapPiattiToDto: function (piatti) {
      return N4M.REMOVEENTRIES(N4M.COPYPOBJECTSARRAY(piatti), [
        "label",
        "details",
        "id",
        "checkbox",
        "modificabile",
      ]);
    },

    setLateralCardOpen: function (details) {
      this.lateralCard.details =
        details != undefined ? details : this.lateralCard.details;

      this.lateralCard.open = !this.lateralCard.open;
    },

    backToVassoio: function () {
      this.$router.push({
        name: nameRoutes.RICHIESTA,
        params: {
          previousIdPasto: this.portata.idVassoio,
        },
      });
    },

    updateUpdateError: function () {
      this.errors.update = !this.errors.update;
    },
  },

  created() {
    this.setAll();
  },
};
